import React, { Component } from "react";
import styled from "styled-components";
import SearchIcon from "@material-ui/icons/Search";
import { ToggleSelect, InputText, ButtonMenu } from "@loanbossinc/component-library";

const StyledHeaderDiv = styled.div`
  margin: .5em 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  span {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
  }
`;

const StyledSelect = styled(ToggleSelect)`
  && {
    margin-left: auto;
  }
`;

const StyledButtonMenu = styled(ButtonMenu)`
  && {
    margin-left: .5em;
  }
`;

const StyledInputText = styled(InputText)`
  && {
    margin-top: 24px;
    margin-bottom: 24px;    
  }
`;
export class DashboardBodyDefaultHeader extends Component {
  render() {
    const {
      title
      , onSearchChange
      , searchText
      , menuOptions
    } = this.props;

    return (
      <>
        <StyledHeaderDiv>
          <span>{title}</span>
          <span style={{ margin: "auto" }} />
          {menuOptions && <StyledButtonMenu hasBorder iconName="more_horiz" options={menuOptions} />}
        </StyledHeaderDiv>

        <StyledInputText
          type="search"
          variant="outlined"
          borderRadius={8}
          placeholder="Search for an asset by name"
          onChange={onSearchChange}
          value={searchText}
          InputProps={{ startAdornment: <SearchIcon /> }}
        />
      </>
    );
  }
}
